import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { axiosInstance } from "./config";

const contactsUrl = "contacts/";

export function useGetMessages() {
  return useQuery({
    queryKey: ["contacts"],
    queryFn: async () => {
      const response = await axiosInstance.get(contactsUrl);
      return response.data;
    },
  });
}

export function useGetUnreadCount() {
  return useQuery({
    queryKey: ["contacts", "unread-count"],
    queryFn: async () => {
      const response = await axiosInstance.get(`${contactsUrl}unread_count/`);
      return response.data;
    },
    refetchInterval: 60000, // Check every minute
  });
}

export function useSendMessage() {
  return useMutation({
    mutationFn: async (data) => {
      return axiosInstance.post(contactsUrl, data);
    },
  });
}

export function useMarkMessageRead() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id) => {
      return axiosInstance.post(`${contactsUrl}${id}/mark_read/`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["contacts"] });
    },
  });
}

export function useDeleteMessage() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id) => {
      await axiosInstance.delete(`${contactsUrl}${id}/`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["contacts"] });
      queryClient.invalidateQueries({ queryKey: ["contacts", "unread-count"] });
    },
  });
}
